import { Divider, Typography } from "@mui/material";
import BrandJoin from "./BrandJoin";
import CountClicks from "./CountClicks";
import SourceAggregation from "./SourceAggregation";
import { Box } from "@mui/system";

const ClickOut = () => {
  return (
    <>
      <hr />
      <br />

      <CountClicks />
      <SourceAggregation />
      <BrandJoin />

      <Divider />
      <Box
        sx={{
          border: "1px solid #BDBDBD",
          borderRadius: "8px",
          backgroundColor: "#FAFAFA",
          p: 1,
          my: 1,
        }}
      >
        <Typography
          sx={{
            color: "#00000099",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          Note: Clicks do not pass through the Fetcher → Unifier → Business
          Adviser pipeline. The value is pre-computed during the daily pipeline
          run and written directly to{" "}
          <strong> final_daily_brand_performance.clicks</strong>. The lineage is
          identical for all brands — no per-brand variation exists.
        </Typography>
      </Box>
    </>
  );
};

export default ClickOut;
